import SplitedCardFields from 'hb-react/shared/components/Payment/components/Stripe/PaymentForm/SplitedCardFields';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

import LegacySplitedCardFields from '../SplitedCardFields';

const SplittedCardFieldsUnderFlag = () => {
  const { flagEvStripeCobrandedCards } = useFeatureFlag();

  return flagEvStripeCobrandedCards ? (
    <SplitedCardFields />
  ) : (
    <LegacySplitedCardFields />
  );
};

export default SplittedCardFieldsUnderFlag;
